module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp13_7005.0cf14d9f.png";